import React from 'react';
import { ChevronDown, ClipboardCheck, Landmark, Building2, Truck, UsersRound, Users, UserPlus, ListChecks } from 'lucide-react';

import Dropdown, { DropdownItem } from '../ui/Dropdown';
import Button from '../ui/Button';

export default function QuickActions({ announcementId, setAction, onAssignTeam, onAssignResponder, onManageRoster, onAssignHospital, canManage }) {
  const handleAssignTeam = () => {
    onAssignTeam();
  };

  const handleViewTeam = () => {
    setAction('assignTeam');
  };

  const handleViewResponses = () => {
    setAction('viewResponses');
  };

  // handleAssignTeam calls onAssignTeam (Incident.jsx), which navigates to the
  // unassigned-teams screen with its own "Assign" button (see TeamCard.js) — that and
  // direct responder/roster actions all write to /api/announcement-member, which is
  // Team Leader+ server-side. This page itself is visible down to Medical Staff, so
  // those need their own gate. "View Teams" here just re-shows the already-assigned
  // (read-only) teams view, and "View Responses"/"Prepare Hospital" are already safe
  // for anyone who can see the page.
  const actions = [
    { icon: ClipboardCheck, name: 'View Responses', handler: handleViewResponses },
    canManage && { icon: Landmark, name: 'Involve Stakeholders', handler: handleAssignTeam },
    { icon: Building2, name: 'Prepare Hospital', handler: onAssignHospital },
    canManage && { icon: Truck, name: 'Assign Ambulance', handler: handleAssignTeam },
    canManage && { icon: UsersRound, name: 'Assign Team', handler: handleAssignTeam },
    canManage && { icon: UserPlus, name: 'Assign Responder', handler: onAssignResponder },
    canManage && { icon: ListChecks, name: 'Manage Roster', handler: onManageRoster },
    { icon: Users, name: 'View Teams', handler: handleViewTeam },
  ].filter(Boolean);

  return (
    <Dropdown
      align="right"
      trigger={({ toggle }) => (
        <Button variant="primary" size="md" onClick={toggle}>
          Quick Actions
          <ChevronDown className="w-4 h-4" />
        </Button>
      )}
    >
      {({ close }) =>
        actions.map((action) => (
          <DropdownItem
            key={action.name}
            icon={action.icon}
            onClick={() => {
              action.handler();
              close();
            }}
          >
            {action.name}
          </DropdownItem>
        ))
      }
    </Dropdown>
  );
}
